import { Injectable } from '@angular/core';

declare var Cap: any;

@Injectable({
  providedIn: 'root'
})
export class CapService {

  constructor() {
  }

  async waitForCap(): Promise<void> {
    if (typeof Cap !== 'undefined') {
      return;
    }
    await new Promise<void>((resolve, reject) => {
      let tries = 0;
      const timer = setInterval(() => {
        tries++;
        if (typeof Cap !== 'undefined') {
          clearInterval(timer);
          resolve();
        } else if (tries > 50) {
          clearInterval(timer);
          reject(new Error('Cap widget failed to load'));
        }
      }, 100);
    });
  }

  async getToken(siteKey: string, url: string): Promise<string> {
    await this.waitForCap();

    const base = String(url || '').replace(/\/+$/, '');
    const key = String(siteKey || '').replace(/^\/+|\/+$/g, '');
    const cap = new Cap({
      apiEndpoint: base + '/' + key + '/'
    });

    try {
      const res: any = await Promise.race([
        cap.solve(),
        new Promise((_, reject) => {
          setTimeout(() => {
            reject(new Error('Captcha solve timed out'));
          }, 8000);
        })
      ]);
      if (!res || !res.success || !res.token) {
        throw new Error('Failed to generate captcha token');
      }
      return res.token;
    } finally {
      if (cap.widget && cap.widget.parentNode) {
        cap.widget.parentNode.removeChild(cap.widget);
      }
    }
  }
}
